import React, { useState, useRef } from "react";
import { motion } from 'framer-motion';
import brand from '../data/brand';
import { SpringCards } from '../components/ui/SpringCards';

const OurBrands = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const ref = useRef(null);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = brand.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(brand.length / itemsPerPage);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            scrollToTop();
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            scrollToTop();
        }
    };

    return (
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-cream">
            {/* Titre principal */}
            <motion.h1
                ref={ref}
                className="text-[#333333] font-light font-cormorant text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 sm:mb-8 uppercase" // Réduction des tailles de police
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                Nos marques.
            </motion.h1>

            {/* Section description */}
            <p className="text-lg sm:text-xl text-gray-700 mb-10">
                Knoll Studio Collection TM
            </p>

            {/* Description de la marque */}
            <div className="prose prose-lg text-[#333333] mb-16">
                <p>
                    Your audio storage should look as good as your music sounds. Our
                    vision is to bring renewed quality and soul to furniture design,
                    creating products that provide generational value and are loved for
                    both the solutions they create and the experiences they enable.
                </p>
            </div>

            {/* Grille de marques */}
            <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-16">
                {currentItems.map((brand, index) => (
                    <div key={index} className="bg-cream rounded-lg shadow-lg overflow-hidden">
                        <SpringCards
                            name={brand.name}
                            description={brand.description}
                            css={brand.css}
                            height={brand.height}
                            imageUrl={brand.imageUrl}
                            link={brand.link}
                        />
                    </div>
                ))}
            </section>

            {/* Pagination */}
            <div className="flex justify-center space-x-4 mt-12">
                <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="px-6 py-2 text-white bg-[#333333] rounded-full disabled:opacity-50 hover:bg-gray-700 transition"
                >
                    Précédent
                </button>
                <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className="px-6 py-2 text-white bg-[#333333] rounded-full disabled:opacity-50 hover:bg-gray-700 transition"
                >
                    Suivant
                </button>
            </div>
        </div>
    );
};

export default OurBrands;